import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import {
  AggregateCommandDTO,
  DeviceDTO,
  FunctionType,
  RoomObjectType,
} from '@/../client-generator/generated-clients/plants';
import {
  getRoomIconFromType,
  getObjectIconFromType,
  getGeneralGroupIconFromType,
} from '@/core/utils/utils';
import DialogConfirmDeleteAggregateCommand from '@/views/components/DialogConfirmDeleteAggregateCommand/DialogConfirmDeleteAggregateCommand.vue';
import DeviceCarousel from '@/views/components/DeviceCarousel/DeviceCarousel.vue';

@Options({
  name: 'CommandGroup',
  props: {
    commandGroup: {
      type: Object as PropType<AggregateCommandDTO>,
      required: true,
    },
    disableActions: {
      type: Boolean,
    },
  },
  components: {
    DialogConfirmDeleteAggregateCommand,
    DeviceCarousel
  },
  emits: ['edit', 'delete', 'add'],
})
export default class CommandGroup extends Vue {
  getRoomIconFromType = getRoomIconFromType;
  getObjectIconFromType = getObjectIconFromType;
  RoomObjectType = RoomObjectType;
  FunctionType = FunctionType;
  isVisibleDeleteAggregateCommandConfirm = false;
  commandGroup!: AggregateCommandDTO;

  get isDefined() {
    return !this.commandGroup.isPlaceholder;
  }

  get isDefinedWithoutCommand() {
    const hasDevices =
      this.commandGroup.devices && this.commandGroup.devices?.length > 0;
    return this.isDefined && !hasDevices;
  }

  get iconName() {
    return getGeneralGroupIconFromType(
      this.commandGroup.type!,
      this.commandGroup.roomObjectType!
    );
  }

  handleEdit() {
    this.$emit('edit');
  }

  handleAdd() {
    this.$emit('add');
  }

  toggleDeleteAggregateCommandConfirm() {
    this.isVisibleDeleteAggregateCommandConfirm = !this
      .isVisibleDeleteAggregateCommandConfirm;
  }

  async handleDeleteAggregateCommand() {
    this.$emit('delete');
  }

  getConfiguredModulesText(device: DeviceDTO) {
    let text = '';
    if (device.slots && this.commandGroup.id) {
        for (const slot of device.slots) {
            if (slot.groups_id && slot.groups_id.includes(this.commandGroup.id)) {
                if (text.length > 0) {
                    text += ' | ' + slot.index;
                } else {
                    text += this.$t('AppResource.Module') + ' ' + slot.index;
                }
            }
        }
    }
    return text;
  }
}
